import { render, staticRenderFns } from "./ProjectGroupsCardItem.vue?vue&type=template&id=2e02044b"
import script from "./ProjectGroupsCardItem.vue?vue&type=script&lang=ts"
export * from "./ProjectGroupsCardItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e02044b')) {
      api.createRecord('2e02044b', component.options)
    } else {
      api.reload('2e02044b', component.options)
    }
    module.hot.accept("./ProjectGroupsCardItem.vue?vue&type=template&id=2e02044b", function () {
      api.rerender('2e02044b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectGroupsCardItem.vue"
export default component.exports